import React from 'react';
import './index.less'

export default () => {
  const origin = process.env.REACT_APP_DSERS_USER_CENTER_ORIGIN;
  return <div className='homebox'>
    <div className='container'>
      <div className='box'>
        <div className='left'>
          <h1>
            Redesign your business model and boost your business development
          </h1>
          <span className='title-desc'>Through DSers Open API, you can join the millions of merchants who operate their business on DSers and create your own application to showcase to even more merchants.</span>
          <h2 className='first'>
            What can I do with DSers?
          </h2>
          <span className='title2-desc'>If you are a supplier or a supply platform, you can create an app to sell your products on DSers, which has served over 1.2 million merchants and processed over 150 million orders all over the world.
          </span>
          <span className='title2-desc' style={{ marginTop: 16, display: 'block', marginBottom: 0 }}>If you are a sales agent or have a sales channel, you can create an app that offers a platform for DSers merchants to build, run and grow their businesses without conncern of fulfillment. </span>
          <span className='title2-desc foter'>By registering as a DSers developer, you can develop an application and complete the launch, embedding it seamlessly into the merchant's workflow. Millions of merchants can then use your application to manage their business.</span>
        </div>
        <div className='right'>
          <img width="100%" src="https://img.dsers.com/dev_site/dev_banner_3.png?a=1" />
        </div>
      </div>
    </div>
    <div className='box2'>
      <div className='box3'>
        <a href={`${origin}/accounts/register?from=dev`} target="_blank"><div className='items2'>Join the developer <img width="85" src="https://img.dsers.com/dsevs_dev/items-1.png" /> </div></a>
        <a href="https://www.dsers.com/developers/supplier-app/" target="_blank"><div className='items2'>How to create <br /> a supplier-side application <img width="85" src="https://img.dsers.com/dsevs_dev/items-2.png" /></div></a>
        <a href="https://www.dsers.com/developers/channel-app/" target="_blank"><div className='items2'>How to create <br /> a sales channel-side application<img width="85" src="https://img.dsers.com/dsevs_dev/items-3.png" /></div></a>
      </div>
    </div>
  </div>
}